export default __webpack_public_path__ + "static/media/banners_3.72e2d51a.png";